import clsx from 'clsx'

import { Badge } from '@/shared/ui/Badge'
import { RewardBadge } from '@/shared/ui/RewardBadge'

import { STORE_NUDGE_COPY } from '../model/constants'

export type StoreNudgeHighlightProps = {
  name: string
  imageUrl: string
  /** Preço em moedas; omitido quando não deve aparecer. */
  price?: number | null
  unlocked?: boolean
  onSelect: () => void
  className?: string
}

/**
 * Card de destaque do popup — o item (moedas) ou o reward destravado. O card
 * inteiro é um botão: toda ação do popup leva à vitrine.
 */
export const StoreNudgeHighlight = ({
  name,
  imageUrl,
  price,
  unlocked = false,
  onSelect,
  className
}: StoreNudgeHighlightProps) => (
  <button
    type="button"
    onClick={onSelect}
    aria-label={`Ver ${name} na lojinha`}
    className={clsx(
      'flex w-full cursor-pointer items-center gap-3 rounded-xl border border-gray-200 bg-white p-3 text-left shadow-sm transition-colors hover:bg-gray-100 active:bg-gray-200',
      className
    )}
  >
    <img
      src={imageUrl}
      alt=""
      loading="lazy"
      decoding="async"
      className="h-16 w-16 shrink-0 rounded-lg bg-gray-100 object-cover"
    />
    <span className="flex min-w-0 flex-1 flex-col gap-1.5">
      <span className="truncate text-sm font-bold leading-snug text-gray-900">
        {name}
      </span>
      <span className="flex flex-wrap items-center gap-2">
        {unlocked && (
          <Badge variant="success" tone="light" showIcon>
            {STORE_NUDGE_COPY.unlockedBadge}
          </Badge>
        )}
        {price != null && (
          <RewardBadge type="coins" value={price} variant="inline" />
        )}
      </span>
    </span>
  </button>
)

StoreNudgeHighlight.displayName = 'StoreNudgeHighlight'
